import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { UserRole } from "../auth/auth-types";
import { useAuth } from "../auth/AuthContext";
import { buildLoginPath } from "../auth/post-login-redirect";

function RedirectToLogin() {
  const location = useLocation();
  return <Navigate to={buildLoginPath(`${location.pathname}${location.search}`)} replace />;
}

export function RequireGoogleAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "anonymous") return <RedirectToLogin />;
  return children;
}

export function RequireRole({
  allow,
  children,
}: {
  allow: Exclude<UserRole, "pending">[];
  children: ReactNode;
}) {
  const { status, profile } = useAuth();
  if (status === "anonymous") return <RedirectToLogin />;
  if (!profile || profile.role === "pending") {
    return <Navigate to="/onboarding" replace />;
  }
  if (!allow.includes(profile.role)) return <Navigate to="/" replace />;
  return children;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { status, isAdmin, adminResolved } = useAuth();
  if (status === "anonymous") return <RedirectToLogin />;
  if (!adminResolved) {
    return (
      <main className="page page-align-start">
        <div className="card card-wide">
          <p className="muted">Loading…</p>
        </div>
      </main>
    );
  }
  if (!isAdmin) return <Navigate to="/teacher" replace />;
  return children;
}
